import { useFilterStore, useStateCounts } from "~/components/build/Show/lib/useFilterStore";
import { FilterByOption } from "~/components/build/Show/lib/filterConstants";
import { useBuildPreferencesStore } from "~/components/build/Show/lib/useBuildPreferencesStore";
import { useBuildStore } from "~/components/build/Show/lib/useBuildStore";
import { buildActionButtonClassName } from "~/components/build/buttonClasses";

/**
 * Empty state shown in the list view when no steps match the active filters
 * and/or display options. Provides quick actions to clear filters or open
 * display options so the user can recover from auto-applied filters that no
 * longer match anything (e.g. "Failed" after retrying all failures).
 */
export default function EmptyState() {
  const filters = useFilterStore((state) => state.filterBy);
  const resetFilters = useFilterStore((state) => state.resetFilters);
  const showSkippedSteps = useBuildPreferencesStore((state) => state.showSkippedSteps);
  const setDisplayOptionsOpen = useBuildStore((state) => state.setDisplayOptionsOpen);
  const stateCounts = useStateCounts();

  const hasFilters = filters.length > 0;
  const hasSkippedHidden = !showSkippedSteps && stateCounts[FilterByOption.Ignored] > 0;

  const subheading = hasFilters
    ? hasSkippedHidden
      ? "Try adjusting your filters or display options."
      : "Try adjusting your filters."
    : hasSkippedHidden
      ? "Try adjusting your display options."
      : "There are no steps to show.";

  return (
    <div
      className="flex flex-1 flex-col items-center justify-center gap-5 px-4 py-16 text-center"
      data-testid="list-empty-state"
    >
      <div className="flex flex-col items-center gap-1">
        <h3 className="text-charcoal-700 m-0 text-base font-semibold">
          No steps match your filters
        </h3>
        <p className="text-charcoal-500 m-0 max-w-sm text-sm">{subheading}</p>
      </div>
      {(hasFilters || hasSkippedHidden) && (
        <div className="flex flex-wrap items-center justify-center gap-2">
          {hasFilters && (
            <button type="button" onClick={resetFilters} className={buildActionButtonClassName}>
              Clear filters
            </button>
          )}
          {hasSkippedHidden && (
            <button
              type="button"
              onClick={() => setDisplayOptionsOpen(true)}
              className={buildActionButtonClassName}
            >
              Show options
            </button>
          )}
        </div>
      )}
    </div>
  );
}
